<footer class="mx-auto mt-20 max-w-[1400px]">
    <div class="grid grid-cols-1 gap-5 lg:grid-cols-5 lg:gap-8 lg:mx-6">
        <a href="https://www.enterprisewireless.org/" class="mx-auto">
            <img
                class="max-w-[200px]"
                src="assets/images/EWA_Logo.jpg"
                alt="EWA Logo"
            />
        </a>
        @for (navigationLink of navigationLinks; track navigationLink) {
            <div class="text-center lg:text-left">
                <h2 class="text-primary-700">{{ navigationLink.text }}</h2>
                <ul>
                    @for (
                        childLink of navigationLink.childLinks;
                        track childLink
                    ) {
                        <li class="pb-3 font-light">
                            <a
                                href="{{ childLink.url }}"
                                class="hover:text-secondary-400"
                                >{{ childLink.text }}</a
                            >
                        </li>
                    }
                </ul>
            </div>
        }
    </div>
    <div class="mt-20 py-5 px-4 text-center opacity-50">
        © {{ currentYear }} Enterprise Wireless Alliance <br />
        <a
            href="https://www.enterprisewireless.org/terms-use"
            class="footer-link"
            >Terms of Use</a
        >
        and
        <a
            href="https://www.enterprisewireless.org/privacy-policy"
            class="footer-link"
            >Privacy Policy</a
        >
    </div>
</footer>
